import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowLeft, CheckCircle, XCircle } from 'lucide-react';

const ReviewGuidelines = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-gradient-to-r from-purple-600 to-purple-700 text-white p-4 flex items-center gap-3">
        <button onClick={() => navigate(-1)} data-testid="back-btn">
          <ArrowLeft className="h-5 w-5" />
        </button>
        <h1 className="text-lg font-bold">{t('reviewGuidelinesTitle', 'Review Guidelines')}</h1>
      </header>

      <div className="max-w-2xl mx-auto p-6 space-y-6">
        <div className="bg-white rounded-xl shadow-sm border p-6">
          <h2 className="text-xl font-bold text-gray-900 mb-4">How to write a helpful review</h2>
          <p className="text-gray-600 mb-4">
            Your reviews help other users discover great local businesses. Please follow these guidelines to ensure your review is approved.
          </p>

          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-gray-900">Be honest and fair</p>
                <p className="text-sm text-gray-600">Share your genuine experience. Honest feedback helps businesses improve.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-gray-900">Be specific</p>
                <p className="text-sm text-gray-600">Mention what you liked or what could be better. Details help others make decisions.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-medium text-gray-900">Keep it relevant</p>
                <p className="text-sm text-gray-600">Focus on the business, its products or services, and your experience.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border p-6">
          <h2 className="text-lg font-bold text-gray-900 mb-4">Reviews may be rejected if they:</h2>
          <div className="space-y-3">
            {[
              'Contain offensive, abusive, or discriminatory language',
              'Include personal attacks or threats',
              'Are spam or promotional content',
              'Contain false or misleading information',
              'Include personal information (phone numbers, addresses)',
              'Are not about the business being reviewed',
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <XCircle className="h-5 w-5 text-red-400 mt-0.5 flex-shrink-0" />
                <p className="text-sm text-gray-700">{item}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-purple-50 border border-purple-200 rounded-xl p-6">
          <p className="text-sm text-purple-800">
            If your review is rejected, you will receive an email with the reason. You can edit and resubmit your review from your profile.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReviewGuidelines;
